module.exports = __webpack_public_path__ + "static/media/293845.0a0a69a8.png";